<template>
  <span v-if="!decisionMade" />
  <!-- <Control v-else /> -->
</template>

<script>
import Cookies from 'js-cookie';
import { identify, track } from '../../analytics/events';
import { deviceOS } from '../../utils/deviceType';
// import Control from '../../views/Disclaimer/mobile.vue';

export default {
  name: 'MMChoiceProvider',
  testExperienceNames: [
    'MYMOVE CHOICE Mobile Disclaimer',
    'Simplify Mobile',
  ],
  testPlacement: 'Disclaimer',
  data() {
    return {
      amp_data: [],
      decisionMade: false,
      showNonControlExperience: false,
      showChoiceExperience: false,
      skipDisclaimer: false,
    };
  },
  computed: {
    flagAmpersendEnabled() {
      return this.$store.get('flagAmpersendEnabled');
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$store.commit('ENABLE_LOADER');
    });
  },
  async mounted() {
    let identifyApp = false;
    this.$resetAppState();
    if (this.$coa.coaUUID || Cookies.get('coa_complete')) {
      sessionStorage.removeItem('showNonControlExperience');
      this.$deleteSession();
      this.$coa.reset();
    } else {
      const { utm_medium: utmMedium } = this.$route.query;
      await this.$coa.coaCreate(utmMedium || '');
      this.$setSession(this.$coa.coaUUID, this.$coa.orderUuid);
      sessionStorage.setItem('coaUUID', this.$coa.coaUUID);
      if (this.flagAmpersendEnabled) {
        const mgoUserAgent = deviceOS();
        this.$amp.setAnonymousID(this.$coa.coaUUID);
        await this.$amp.identify({
          mgoDeviceType: 'MOBILE',
          isVerified: false,
          mgoUserAgent,
        });
        identifyApp = true;
      }
      identify(this.$coa.coaUUID);
      track('CoaCreated', {
        uuid: this.$coa.coaUUID,
        visitId: this.$coa.visitId,
      });
    }

    const splits = this.flagAmpersendEnabled ? await this.$amp.getUnimpressedExperiences() : [];
    this.amp_data = [...this.amp_data, ...splits];
    sessionStorage.setItem('amp_data', JSON.stringify(this.amp_data));

    const {
      accountId, agentId, audienceId, experienceGroupId, id, name,
    } = splits.find(this.findTestExperience) || {};
    if (splits?.length) {
      const names = splits.map((exp) => exp.name.trim());
      this.showChoiceExperience = names.includes(this.$options.testExperienceNames[0]);
      this.showNonControlExperience = names.includes(this.$options.testExperienceNames[1]);
      if (agentId) {
        track('DecisionMade', {
          agentId,
          name,
        });
      }
      sessionStorage.setItem('showChoiceExperience', (this.showChoiceExperience || this.showNonControlExperience));
      sessionStorage.setItem('showNonControlExperience', (this.showChoiceExperience || this.showNonControlExperience));
      sessionStorage.setItem('skipDisclaimerExperience', this.skipDisclaimer);
    }
    if (agentId && id && this.showNonControlExperience) {
      sessionStorage.setItem('ampexp_data', JSON.stringify({
        accountId, agentId, audienceId, id, experienceGroupId,
      }));
    }
    if (identifyApp) {
      // Note: This property can't be update in the initial call to '$amp.identify'
      // since it depends on a call to response from '$amp.getUnimpressedExperiences'
      // which requires an initial call to '$amp.identify'. Therefore this property
      // 'mgoApplication' should preferably be used in AMP post global experiences
      await this.$amp.identify({
        mgoApplication: this.showChoiceExperience || this.showNonControlExperience ? 'simplify' : 'control',
      });
    }

    this.decisionMade = true;
    this.$store.commit('DISABLE_LOADER');
    this.$router.push({ name: 'move-combined-mobile', query: this.$route.query });
  },
  methods: {
    findTestExperience({ templates: [template] }) {
      return template.properties.name === this.$options.testPlacement;
    },
  },
};
</script>
